var map = {
	"./agents-red.svg": 68106,
	"./calendar-red.svg": 55000,
	"./clock-red.svg": 97967,
	"./language-icon-red.svg": 52339,
	"./properties-red.svg": 50997,
	"./settings-red.svg": 47730
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 66385;